<template>
    <u-chip-outlined-tile v-bind="$attrs" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-chip-outlined-tile>
</template>

<script>
import UChipOutlinedTile from "@/components/publish/styles/chips/u-chip-outlined-tile.vue";

export default {
    props: {},
    components: {
        UChipOutlinedTile,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
